export const publishedFilter = (data) =>
  process.env.GATSBY_ENV === 'production'
    ? data.filter(({ status }) => status === 'published')
    : data;

export const publishedPageMapFilter = (data) =>
  process.env.GATSBY_ENV === 'production'
    ? data.filter(({ status }) => status === 'published')
    : data;
